var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKyCiconBank({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A738",
    d: "M15.201 15.613h3.549v9.939h-3.549z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.665 13.86h4.654v1.169c0 .323-.32.584-.716.584h-3.222c-.395 0-.716-.261-.716-.584v-1.17zM19.334 27.305H14.68v-1.17c0-.323.32-.584.716-.584h3.221c.396 0 .716.262.716.584v1.17z",
    fill: "#FEC93E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A738",
    d: "M6.684 15.602h3.549v9.939H6.684z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.148 13.848h4.654v1.169c0 .323-.32.585-.716.585H6.864c-.395 0-.716-.262-.716-.585v-1.17zM10.817 27.297H6.163v-1.17c0-.322.32-.584.716-.584H10.1c.395 0 .716.262.716.585v1.169z",
    fill: "#FEC93E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A738",
    d: "M23.876 15.613h3.549v9.939h-3.549z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.34 13.86h4.654v1.169c0 .323-.32.584-.716.584h-3.222c-.395 0-.716-.261-.716-.584v-1.17zM28.008 27.305h-4.653v-1.17c0-.323.32-.584.715-.584h3.222c.396 0 .716.262.716.584v1.17z",
    fill: "#FEC93E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.573 12.102h24.863v1.169c0 .323-.247.585-.553.585H5.126c-.306 0-.553-.262-.553-.585V12.1zM29.709 29.059H4.293v-1.17c0-.323.248-.584.553-.584h24.31c.305 0 .553.261.553.584v1.17z",
    fill: "#F7A738"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.814 30.813H3.19v-1.17c0-.323.247-.585.552-.585h26.52c.306 0 .553.262.553.585v1.17zM3.188 10.938h27.625v.584c0 .323-.247.585-.553.585H3.74c-.305 0-.553-.262-.553-.585v-.585zM17.138 3.188l13.675 7.746H3.188l13.95-7.746z",
    fill: "#FEC93E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8.5,
    r: 2.125,
    fill: "#F7A738"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKyCiconBank);
export default __webpack_public_path__ + "static/media/KYCiconBank.1b2e0ba218e0fb356cdc67fbc6a0f4eb.svg";
export { ForwardRef as ReactComponent };